// About.js
import React from 'react';
import './About.css';
import Union from '../Assets/icons/Union.svg'; // Update path as needed
import Cheap from "../Assets/icons/article.svg";

const About = ({ onCategoryButtonClick }) => {
  // TODO: Uncomment return statement below to show buttons when needed
  return null; // Hidden for now - Budget 2026

  const handleButtonClick = (category, button) => {
    onCategoryButtonClick(category, button);
  };

  return (
    <div className="about-container">
      <div className="category">
        <button className="category-button" onClick={() => handleButtonClick('Income Tax', 'Tax Indicator')}>
          <img src={Union} alt="Tax Indicator" className="button-icon" />
          Tax Indicator
        </button>
        <button className="category-button" onClick={() => handleButtonClick('Budget', 'What got Cheaper')}>
          <img src={Cheap} alt="Cheaper" className="button-icon" />
          What got Cheaper
        </button>
        <button className="category-button" onClick={() => handleButtonClick('Budget', 'What got Expensive')}>
          <img src={Cheap} alt="Expensive" className="button-icon" />
          What got Expensive
        </button>
      </div>
    </div>
  );
}

export default About;
